import {TOKEN_NAME} from '../config/config';
import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {decodeJWT, deleteCookie, getCookie, informLanguageChange, setCookie} from '../utils/helper';
import {getToken, tokenExists} from '../utils/tokenUtils';
// import useLogin from "../hooks/useLogin";


// ---------------------------------------------------------------------------------------------------------------
const isValidLanguageValue = (language) => ['en', 'gr'].includes(language);
const initLanguageValue = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const newLanguage = urlParams.get('l');
  const cookie = getCookie('LANG');
  if (urlParams.has('l') && isValidLanguageValue(newLanguage)) {
    setCookie('LANG', newLanguage, 1);
    window.sessionStorage.setItem('LANG', 'en');
    return newLanguage;
  } else if (isValidLanguageValue(cookie)) {
    return cookie;
  }
  deleteCookie('LANG');
  window.sessionStorage.setItem('LANG', 'gr');
  return 'gr';
};
const onLanguageChange = (newLanguage, oldLanguage, informUpdate = true) => {
  if (isValidLanguageValue(newLanguage) && newLanguage !== oldLanguage) {
    setCookie('LANG', newLanguage, 1);
    if(informUpdate){
      informLanguageChange();
    }
    return newLanguage;
  }
  return oldLanguage;
};
// ---------------------------------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------------------------------
const GlobalContext = React.createContext(null);
// ---------------------------------------------------------------------------------------------------------------
/**
 * @property {string} channel current channel
 * @property {string} lang current language
 * @property {string} authToken current token
 * @property {string} guid current guid
 * @property {object} userData current user data
 * @property {function(string): void} setLang language setter
 * @property {function(string): void} setAuthToken token setter
 */
class GlobalContextParams {
  constructor( lang, setLang) {
    this.lang = lang;
    this.setLang = setLang;

  }
}
/** @return {GlobalContextParams} */
const useInitGlobalContext = () => {
  const location = useLocation();

  const [lang, setLang] = useState(initLanguageValue());


  const onUiLanguageChange = (newLanguage) => {
    window.sessionStorage.setItem('LANG', newLanguage);
    setLang(onLanguageChange(newLanguage, lang));
  };




  return new GlobalContextParams( lang,onUiLanguageChange);
};
/** @return {GlobalContextParams}*/
export const useGlobalContext = () => {
  const params = useContext(GlobalContext);
  if (params == null) {
    throw new Error('Error: global context not initialized');
  }
  return params;
};
// ---------------------------------------------------------------------------------------------------------------
export const ContextProvider = ({ children }) => {
  const globalCtxValue = useInitGlobalContext();
  return <GlobalContext.Provider value={globalCtxValue}>{children}</GlobalContext.Provider>;
};
